<template>
  <v-container class="fill-height d-flex justify-center align-center">
    <v-overlay :value="show">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <v-card class="elevation-12" width="400">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="login">
          <v-text-field
            v-model="email"
            label="Correo Electrónico"
            type="email"
            required
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Contraseña"
            required
            outlined
            dense
            :append-icon="viewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="viewPassword ? 'text' : 'password'"
            @click:append="viewPassword = !viewPassword"
          ></v-text-field>
          <!--  
          :rules="[rules.required, rules.min]"
            
          -->
          <v-alert dense outlined type="warning" v-if="showPassword">{{
            msg
          }}</v-alert>
          <v-btn block color="primary" type="submit" class="mt-4">
            Iniciar Sesión
          </v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <!--v-btn text color="primary">¿Olvidaste tu contraseña?</v-btn-->
      </v-card-actions>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  data: () => ({
    email: "",
    password: "",
    showPassword: false,
    show: false,
    msg: null,
    viewPassword: false,
  }),
  methods: {
    async login() {
      //this.msg = null;
      this.show = true;
      this.$store
        .dispatch("auth/login", {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          //console.log(res);
          if (res.status == 200) {
            this.$router.push("/").catch(() => {});
          }
          this.show = false;
        })
        .catch((err) => {
          //console.log(err);
          if (err.response.status == 401) {
            // this.msg = "Usuario o Contraseña incorrecta";
            // console.log();
            this.msg = err.response.data.message;
            this.showPassword = !this.showPassword;
          } else {
            this.msg = err.response.data.msg;
          }
          this.show = false;
        });
    },
  },
};
</script>
  
  <style scoped>
.fill-height {
  height: 100vh;
  background: linear-gradient(to bottom right, #2196f3, #e3f2fd);
}
</style>
  